import ru from 'date-fns/locale/ru';
import en from 'date-fns/locale/en-US';

const getDateFnsLocale = locale => {
  if (locale === 'ru') {
    return ru;
  }

  return en;
};

export default getDateFnsLocale;
